import { render, staticRenderFns } from "./modal-delete-confirmation.vue?vue&type=template&id=2f7397e6&"
import script from "./modal-delete-confirmation.vue?vue&type=script&lang=js&"
export * from "./modal-delete-confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports